import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import storageService from '@shared/storage/storageService';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  selectedLanguage = "fr";

  constructor(
		private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.setLanguage();
  }

  setLanguage() {
		this.selectedLanguage = storageService.getItem("language");
		this.translate.use(this.selectedLanguage);
	}

}
